// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3SN0W","dragIcon":"Choice_dragIcon__3AhDs","left":"Choice_left__2Y2i4","input":"Choice_input__1NWDm"};